import { green, red } from '@mui/material/colors';
import SituacaoIdDescricaoBase from './SituacaoIdDescricaoBase';

/**
 * Enum para situações de Análise Pre-Sessão.
 *
 * @readonly
 * @constant
 * @enum {Object.<string, Object>}
 */
// prettier-ignore
export const SITUACAO_ANALISE = {
    VALIDADO      : { id: 'VALIDADO',      descricao: 'Validado',      iconeSucesso: true,  cor: green[900] },
    PENDENTE      : { id: 'PENDENTE',      descricao: 'Pendente',      iconeSucesso: false, cor: red[900]   },
    SEM_VALIDACAO : { id: 'SEM_VALIDACAO', descricao: 'Sem validação', iconeSucesso: false, cor: 'gray'     }
};

/**
 * @classdesc Facilita o acesso às propriedades e valores da enum de situações de Análise Pre-Sessão.
 * @readonly
 */
export default class SituacaoAnalise {
    static situacaoBase = new SituacaoIdDescricaoBase(SITUACAO_ANALISE);
    static MSG_ERRO_IDENTIFICACAO_SITUACAO_ANALISE = 'Não foi possível identificar a análise da situação.';

    static get(id) {
        return SituacaoAnalise.situacaoBase.getObjectById(id);
    }

    static getDescricao(id) {
        return SituacaoAnalise.situacaoBase.getDescricao(id);
    }

    static getCor(id) {
        return SituacaoAnalise.situacaoBase.getValorPropriedade(id, 'cor');
    }
}
